// src/components/Reports/WebsiteSelector.js
import React from 'react';
import { Card, Button, Form, Badge } from 'react-bootstrap';

const WebsiteSelector = ({
                             websites,
                             selectedWebsites,
                             onWebsiteToggle,
                             onSelectAll,
                             onSelectNone
                         }) => {
    return (
        <Card className="shadow-sm h-100">
            <Card.Header className="bg-white">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Zobrazené weby</h5>
                    <Badge bg="primary" pill>{selectedWebsites.length}</Badge>
                </div>
            </Card.Header>
            <Card.Body>
                <div className="d-flex justify-content-between mb-3">
                    <Button variant="outline-primary" size="sm" onClick={onSelectAll}>
                        <i className="fas fa-check-double me-1"></i> Vybrat vše
                    </Button>
                    <Button variant="outline-secondary" size="sm" onClick={onSelectNone}>
                        <i className="fas fa-times me-1"></i> Zrušit výběr
                    </Button>
                </div>

                <div className="websites-list max-h-300 overflow-auto">
                    {websites.map(website => (
                        <Form.Check
                            key={website.id}
                            type="checkbox"
                            id={`website-check-${website.id}`}
                            label={
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <span className="text-truncate">{website.name || website.url}</span>
                                    <span
                                        className={`status-dot ${website.status === 'online' ? 'bg-success' : website.status === 'issues' ? 'bg-warning' : 'bg-danger'}`}
                                    ></span>
                                </div>
                            }
                            checked={selectedWebsites.includes(website.id)}
                            onChange={() => onWebsiteToggle(website.id)}
                            className="mb-2 p-2 border-bottom"
                        />
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default WebsiteSelector;